import { HttpClient } from "../../../../common/services/http-client.service";
import { ApiResult } from "../../../../common/models";
import { documentTypeConfigConfig } from "../config/document-type-config.config";

export interface DocumentTypeConfigResponse {
  config_name: string;
  config_payload: string;
  doc_type_id: number | string;
  document_type: string;
  created_by: string;
  company_name: string;
  data_exposer: string;
  department: string;
  document_context: string;
  field_context: string;
  extraction_model: string;
  chat_exposure: string;
  clause_extraction: string;
  summarization_fields: string;
  group_by_field: string;
  batch_process_exposure: boolean;
  sharepoint_url: string;
  id: number;
}

export interface ConfigOption {
  config_id: number;
  config_name: string;
  doc_type_id: number | string;
}

export class DocumentTypeConfigService extends HttpClient {
  private static readonly BASE_URL = `/gdx/database/config/get-all`;

  static async getDocumentTypeConfigurations(
    documentType: string
  ): Promise<ApiResult<DocumentTypeConfigResponse[]>> {
    const config = documentTypeConfigConfig.getAllDocumentTypeConfigurations();
    try {
      const response = await this.invokeApi<DocumentTypeConfigResponse[]>(
        config
      );

      // Filter by document type
      // Map UI document type names to API document type values
      const documentTypeMapping: { [key: string]: string } = {
        Engineering: "Engineering",
        engineering: "Engineering",
        Contract: "Contract",
        contract: "Contract",
        Invoice: "Invoice",
        invoice: "Invoice",
        Others: "Others",
        others: "Others"
      };

      return new ApiResult<DocumentTypeConfigResponse[]>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    } catch (error) {
      console.error("Error fetching document type configurations:", error);
      const errorMessage =
        error instanceof Error ? error.message : "Unknown error occurred";
      return new ApiResult<DocumentTypeConfigResponse[]>(
        [] as any,
        500,
        errorMessage
      );
    }
  }

  static getUniqueConfigOptions(
    configs: DocumentTypeConfigResponse[]
  ): ConfigOption[] {
    // Get unique configurations by id
    const uniqueConfigs = configs.reduce((acc, config) => {
      if (!acc.some((item) => item.config_id === config.id)) {
        acc.push({
          config_id: config.id,
          config_name: config.config_name,
          doc_type_id: config.doc_type_id
        });
      }
      return acc;
    }, [] as ConfigOption[]);

    return uniqueConfigs;
  }
}
